var ButtonLine = (function () {
  

  var $buttonLines;

  var $line;

  var defaultScrollFactor;

  var defaultColor = 'white';

  function init() {
    $buttonLines = $('[data-acr-button-line]');

    defaultScrollFactor = 0.7;

    createLine();

    attachScroll();

    attachResize();

    scroll();
  }

  function createLine() {
    $line = $('<div/>', {
      class: 'acr-button-line',
    });

    $('body').prepend($line);
  }

  function attachScroll() {
    $(window).off('scroll', scroll)
      .on('scroll', scroll);
  }

  function attachResize() {
    $(window).off('resize', scroll)
      .on('resize', scroll);
  }

  function drawLine($anchor, $window, elHeight, scrollFactor, color) {
    var winTop = $window.scrollTop();

    var winBottom = winTop + $window.height();

    var elTop = $anchor.offset().top;

    var elBottom = elTop + $anchor.outerHeight();

    if ((elTop < winBottom)) {
      var height = (winBottom - elTop) * scrollFactor;

      if (elHeight > height) {
        $line.height(height);
      } else {
        $line.height(elHeight);
      }

      $line.css({
        top: elBottom,
        'background-image': 'linear-gradient(to bottom,' + color + ', transparent)',
      });
    }
  }

  function scroll() {
    var $window = $(window);

    if ($window.innerWidth() < Constants.breakpoints.sm) {
      return;
    }

    $buttonLines.each(function (i, lineAnchor) {
      var elHeight;

      var $lineAnchor = $(lineAnchor);

      if ($lineAnchor.attr('data-enable') === undefined) {
        return;
      }

      var scrollFactor = $lineAnchor.data('scrollFactor')
        || defaultScrollFactor;

      var color = $lineAnchor.data('color')
        || defaultColor;

      if ($window.innerWidth() < Constants.breakpoints.sm) {
        elHeight = $lineAnchor.data('smHeight');
      } else if ($window.innerWidth() < Constants.breakpoints.lg) {
        elHeight = $lineAnchor.data('mdHeight');
      } else if ($window.innerWidth() < Constants.breakpoints.xl) {
        elHeight = $lineAnchor.data('lgHeight');
      } else {
        elHeight = $lineAnchor.data('xlHeight');
      }

      drawLine($lineAnchor, $window, elHeight, scrollFactor, color);
    });
  }

  return {
    init: init,
    scroll: scroll,
  };
}());
